import { Typography, styled } from "@mui/material";

export const Text = styled(Typography)(({ theme }) => ({
  ...theme.typography.pl3,
  color: theme.palette.primary.darkGray70,
  textAlign: 'center',
}));